export const DEFAULT_PLACEHOLDER = "None"; 
export const DEFAULT_CHUNK = 50;
export const APP_MAINTENANCE_BANNER_ID= "app-maintenance-banner"